// extracted by mini-css-extract-plugin
module.exports = {"modal":"CommentModal_modal__SXf8g"};